// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + ({"179":"components","216":"react-core","231":"iframe-resizer-js-iframeResizer","587":"react-dom"}[chunkId] || chunkId) + "." + {"143":"e8e96a3c77e4225a5f9c","179":"9ec50743ca097deaf847","216":"731b7711aaa3a0c434d7","231":"1b0d6c6f6787bd45be33","482":"f68c0038151ea2f239b3","587":"74b10e2ac694235b766e"}[chunkId] + ".js";
};